import React from 'react';
import { array, func, string } from 'prop-types';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';
import { Default, Mobile } from '../../Sizes';

function EditOptions(props) {
	return (
		<React.Fragment>
			<Default>
				<Presenter {...props} />
			</Default>
			<Mobile>
				<MobilePresenter {...props} />
			</Mobile>
		</React.Fragment>
	);
}
EditOptions.propTypes = {
	data: array,
	onDelete: func,
	onSort: func,
	answer: string,
};

export default EditOptions;